import { render, staticRenderFns } from "./RelatorioLogAnoSerie.vue?vue&type=template&id=bd208768&scoped=true"
import script from "./RelatorioLogAnoSerie.vue?vue&type=script&lang=js"
export * from "./RelatorioLogAnoSerie.vue?vue&type=script&lang=js"
import style0 from "./RelatorioLogAnoSerie.vue?vue&type=style&index=0&id=bd208768&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd208768",
  null
  
)

export default component.exports